module.exports = __webpack_public_path__ + "static/gooding-b7c5162811d2e74a1657e4c3cce67ff8.png";